export default {
      id: "i-tg-circle-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/sprite.svg#i-tg-circle",
      toString: function () {
        return this.url;
      }
    }